import { z } from "zod";
import { providerTypeSchema } from "../search/discovery-search.contract.ts";

export const findFeedRowKeys = [
    "great-for-families",
    "from-breeders",
    "from-shelters",
    "hypoallergenic",
    "first-time-owners",
    "good-with-cats",
    "active-adventurous",
    "calm-easygoing",
    "healthy-breeds",
] as const;

const findFeedRowKeySchema = z.enum(findFeedRowKeys);

export type FindFeedRowKey = z.infer<typeof findFeedRowKeySchema>;

export const findFeedProjectionRowsSchema = z.array(
    z.object({
        lane: z.union([z.literal("featured"), findFeedRowKeySchema]),
        id: z.string().min(1),
    }),
);

export const heroListingProjectionRowsSchema = z.array(
    z.object({ id: z.string().min(1) }),
);

const coordinateSchema = z.coerce.number().catch(Number.NaN);
const optionalNumber = z.coerce.number().optional().catch(undefined);

export const findFeedInputSchema = z
    .object({
        lat: coordinateSchema,
        lng: coordinateSchema,
        providerType: providerTypeSchema.optional(),
        limitPerRow: optionalNumber,
    })
    .loose();

export type FindFeedInput = z.infer<typeof findFeedInputSchema> & {
    includeListingDocuments?: boolean;
};

export const nearestDogsInputSchema = z
    .object({
        lat: coordinateSchema,
        lng: coordinateSchema,
        providerType: providerTypeSchema.optional(),
    })
    .loose();

export type NearestDogsInput = z.infer<typeof nearestDogsInputSchema>;

const findRowDoomscrollDirectionSchema = z.enum(["around", "next", "prev"]);

export const findRowDoomscrollInputSchema = z
    .object({
        lat: coordinateSchema,
        lng: coordinateSchema,
        rowKey: findFeedRowKeySchema,
        listingId: z.string(),
        limit: optionalNumber,
        direction: findRowDoomscrollDirectionSchema.optional(),
    })
    .loose();

export type FindRowDoomscrollInput = z.infer<
    typeof findRowDoomscrollInputSchema
>;
